import { Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export default function StatDescriptionTooltip({ description, fontSize = 18 }) {
  if (!description) return null;

  return (
    <Tooltip title={description} arrow>
      <HelpOutlineIcon
        sx={{ fontSize, color: "text.secondary", cursor: "help" }}
      />
    </Tooltip>
  );
}
